import Route from 'cio/routes/base';

export default class DraftsRoute extends Route {
  redirect() {
    this.router.transitionTo('outbox.list.drafts');
  }
}
